"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _bookingHistoryJp = require("@/api/bookSpace/bookingHistoryJp");
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    showList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    delPermit: {
      type: String,
      default: ''
    },
    isInRow: Boolean,
    disabledFlag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null
    };
  },
  created: function created() {
    this.$permissions.loadPermissions('/standard');
  },
  computed: {
    isChecked: {
      get: function get() {
        // 将 0 转换为 false，将 1 转换为 true
        return this.value == "1";
      },
      set: function set(newValue) {
        // 将 true 转换为 1，将 false 转换为 0
        this.value = newValue ? "1" : "0";
      }
    }
  },
  methods: {
    frDownload: function frDownload(id) {
      (0, _bookingHistoryJp.downFRForm)(id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/pdf'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', 'FreightMemo-' + res.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    validateNull: _validate.validateNull,
    handlePath: function handlePath() {
      this.$emit('handlePath', this.row);
    },
    handleDownload: function handleDownload() {
      this.$emit('handleDownload', this.row);
    },
    handlePass: function handlePass() {
      this.$emit('handlePass', this.row);
    },
    handleDel: function handleDel() {
      this.$emit('handleDel', this.row, this.isInRow);
    },
    handleConfirm: function handleConfirm() {
      this.$emit('handleConfirm', this.row, this.isInRow);
    },
    handleCancelConfirm: function handleCancelConfirm() {
      this.$emit('handleCancelConfirm', this.row, this.isInRow);
    },
    handleCancel: function handleCancel() {
      this.$emit('handleCancel', this.row, this.isInRow);
    },
    handleCreate: function handleCreate() {
      this.$emit('handleCreate', this.row);
    },
    handleOpenDiaglog: function handleOpenDiaglog() {
      this.$emit('handleOpenDiaglog', this.row);
    },
    setContractSeal: function setContractSeal() {
      this.$emit('setContractSeal', this.row);
    },
    handleCharterer: function handleCharterer() {
      this.$emit('handleCharterer', this.row, this.prop);
    },
    handleViewContract: function handleViewContract() {
      this.$emit('handleViewContract', this.row);
    },
    changeIsShip: function changeIsShip() {
      this.$emit('changeIsShip', this.value, this.row);
    },
    changeIsLow: function changeIsLow() {
      this.$emit('changeIsLow', this.value, this.row);
    },
    changeIsOverload: function changeIsOverload() {
      this.$emit('changeIsOverload', this.value, this.row);
    }
  }
};